export class CallBack {

  constructor(
    public name: string,
    public email: string,
    public phone: string) {
  }
}
